import { createRoute, useSearch } from "@tanstack/solid-router";
import { useNavigate } from "@/lib/u-router";
import { isDateKey } from "@mealplan/shared";
import { appRoute } from "./route";
import { InsightsView } from "@/features/insights/components/insights-view";
import { PageContainer } from "@/components/ui/page-container";
import { AppErrorBoundary } from "@/components/error-boundary";

interface InsightsSearch {
  week?: string;
}

function InsightsPage() {
  const search = useSearch({ from: "/u/$u/insights" });
  const navigate = useNavigate();

  // Persiste la semana activa en la URL (deep-link `?week=YYYY-MM-DD`), igual que
  // el planner. `replace` evita inflar el historial al paginar de semana en semana.
  const syncUrl = (weekStartKey: string): void => {
    if (weekStartKey === (search().week ?? "")) {
      return;
    }
    void navigate({
      to: "/insights",
      search: { week: weekStartKey },
      replace: true,
    });
  };

  return (
    <PageContainer maxWidth="5xl">
      <AppErrorBoundary variant="page" region="insights">
        <InsightsView initialWeek={search().week} onWeekChange={syncUrl} />
      </AppErrorBoundary>
    </PageContainer>
  );
}

export const insightsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/insights",
  validateSearch: (search: Record<string, unknown>): InsightsSearch => ({
    week: typeof search.week === "string" && isDateKey(search.week) ? search.week : undefined,
  }),
  component: InsightsPage,
});
